var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ViewUiCalloutIcon',{staticClass:"view-ui-state-nocheckins",attrs:{"iconFilename":"pin.svg","message":'A history of user checkins<br />will appear here'}},[_c('div',{staticClass:"actions push-top-xl"},[_c('ViewUiButtonBack',{staticClass:"button-tertiary"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }